import type { ActionReturn } from "svelte/action";
import { on } from "svelte/events";
import { setHugeHeadingParallax } from "./setHugeHeadingParallax.js";

export function hugeHeadingParallax(element: HTMLElement): ActionReturn {
	setHugeHeadingParallax(element);

	return {
		destroy: on(window, "scroll", () => {
			setHugeHeadingParallax(element);
		}),
	};
}
